'use client'

import type { ComponentProps } from 'react'
import { Button as SystmButton } from '@indxsearch/systm'
import styles from './MdxClient.module.css'

// systm/Callout don't ship a "use client" directive, so re-exporting them through
// this client module turns them into client references. That lets the RSC MDX
// renderer emit them as client components instead of trying to evaluate them on
// the server (which fails: "Class extends value undefined").
export { Chip } from '@indxsearch/systm'
export { default as Callout } from '@/components/Callout'

/**
 * systm <Button> renders an inline-flex anchor, so on its own line in an article
 * it gets no block spacing. Wrap it in a block element to give standalone buttons
 * room below them.
 */
export function Button(props: ComponentProps<typeof SystmButton>) {
  return (
    <div className={styles.buttonRow}>
      <SystmButton {...props} />
    </div>
  )
}
